import { cyan, gray } from '@carbon/colors';

export const mapColors = {
  surfaceHoleFill: '#D91B1B',
  bottomHoleFill: '#3BAB5A',
  stickFill: '#0F62FE',
  verticalFill: '#2E2E2E',
  surveyFill: '#001141',
  pricingFill: '#575757',
  unitsFill: '#08BDBA',
  typeCurvesFill: '#FA9494',
  basinFill: '#57E5E5',
  tierFill: '#F1C21B',
  surfaceInterestFill: '#9F1853',
  royaltyInterestFill: '#42BE65',
  workingInterestFill: '#4589FF',
  unleasedFill: '#FFFF00',

  // Well intersection unit colors
  assignedUnitFill: cyan[20],
  assignedUnitBorder: cyan[50],
  nonAssignedUnitFill: gray[50],
  nonAssignedUnitBorder: gray[80],

  scopedAssetsFill: '#3388FF',
  scopedAssetsBorder: '#006AFF',
  scopedAssetsUnselectedFill: gray[40],
  scopedAssetsUnselectedBorder: gray[60],
  scopedTitleFill: '#A9BEC7',
  scopedTitleBorder: '#678597',
  scopedUnitsFill: '#B833FF',
  scopedUnitsBorder: '#A600FF',
  scopedVerticalFill: '#A68CA5',
  scopedVerticalBorder: '#906F8F',
  scopedHorizontalProFill: '#78BA83',
  scopedHorizontalProBorder: '#56A964',
  scopedHorizontalDucFill: '#515151',
  scopedHorizontalDucBorder: '#2F2F2F',
  scopedHorizontalPerFill: '#8DDB9A',
  scopedHorizontalPerBorder: '#61C772',
  drillingRigHorizontalDrillingFill: '#198038',
  drillingRigHorizontalDrillingBorder: '#000000',
  drillingRigVerticalDrillingFill: '#DA1E28',
  drillingRigVerticalDrillingBorder: '#000000',
  drillingRigHorizontalDownFill: '#DA1E28',
  drillingRigHorizontalDownBorder: '#000000',
  drillingRigVerticalDownFill: '#DA1E28',
  drillingRigVerticalDownBorder: '#000000',
  drillingRigHorizontalNotReportingFill: '#525252',
  drillingRigHorizontalNotReportingBorder: '#000000',
  drillingRigVerticalNotReportingFill: '#525252',
  drillingRigVerticalNotReportingBorder: '#000000',
  drillingRigHorizontalNotTrackingFill: '#525252',
  drillingRigHorizontalNotTrackingBorder: '#000000',
  drillingRigVerticalNotTrackingFill: '#525252',
  drillingRigVerticalNotTrackingBorder: '#000000',
  drillingRigHorizontalUnreportedStatusFill: '#525252',
  drillingRigHorizontalUnreportedStatusBorder: '#000000',
  drillingRigVerticalUnreportedStatusFill: '#525252',
  drillingRigVerticalUnreportedStatusBorder: '#000000',

  /** Focus area map/checkbox color per category (single source of truth for selector + map layer). */
  focusAreaFault: '#EB6200',
  focusAreaRegulatory: '#0F62FE',
  defaultFocusArea: '#EB6200',

  /** CRM Tract wizard `<ScopedMapPanel>` overlays. */
  crmScopedSelectedUnitFill: '#a6c8ff',
  crmScopedSelectedUnitLine: '#0043ce',
  crmScopedSubtractLine: '#f1c21b',
  crmScopedUatFill: '#4589ff',
  crmScopedSelectedSlotLine: '#000000',
  crmScopedThresholdAboveFill: '#24A148',
  crmScopedThresholdBelowFill: '#DA1E28',
};

/** Category name -> hex color for focus areas (map fill/line and selector checkboxes). */
export const focusAreaCategoryColors: Record<string, string> = {
  Fault: mapColors.focusAreaFault,
  Regulatory: mapColors.focusAreaRegulatory,
};

export const defaultFocusAreaColor = mapColors.defaultFocusArea;
